import { EXCHANGE_HANDOFF_CODE } from "constants/apiEndpoints";
import { AUTH_SOURCE, AXIOS_METHODS } from "constants/common";
import { AbilityContext } from "contexts/can";
import { useAxios } from "hooks";
import { useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { processUserLogin } from "services/redux/thunk/user";

const useHandoff = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  const {
    triggerApi: triggerExchange,
    response: exchangeResponse,
    success: exchangeSuccess,
  } = useAxios({
    method: AXIOS_METHODS.POST,
    url: EXCHANGE_HANDOFF_CODE,
    onInit: false,
  });

  const exchangeCalled = useRef(false);

  useEffect(() => {
    if (exchangeCalled.current) return;
    exchangeCalled.current = true;

    if (isAuthenticated) {
      navigate("/", { replace: true });
      return;
    }

    const code = searchParams.get("code");
    if (!code) {
      navigate("/auth/login", { replace: true });
      return;
    }

    triggerExchange({ data: { code } });
  }, []);

  useEffect(() => {
    if (exchangeSuccess === true) {
      dispatch(
        processUserLogin({
          apiResponse: exchangeResponse,
          type: AUTH_SOURCE.LOGIN,
          ability,
        })
      );
      navigate("/", { replace: true });
    }

    if (exchangeSuccess === false) {
      navigate("/auth/login", { replace: true });
    }
  }, [exchangeSuccess, exchangeResponse, dispatch, ability]);
};

export default useHandoff;
